import styled from "styled-components";

export const InputGroup = styled.div`
  display: inline-flex;
  align-items: center;
  > *:not(:last-child) {
    margin-right: 0.6rem;
  }
`;
